import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Globe, Check } from "lucide-react";
import { useI18n, LANGUAGES, isTranslatableRoute } from "@/i18n";

// Always-on language control, fixed to the top-right of every page (public site
// and all portals) so a patient can switch language from anywhere.
export default function FloatingLanguageSwitcher() {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const loc = useLocation();
  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);
  // Hidden on Doctor / Admin / Customer-Support consoles.
  if (!isTranslatableRoute(loc.pathname)) return null;
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  return (
    <div className="fl-lang" ref={ref} data-no-translate data-testid="floating-language-switcher">
      <button className="fl-lang-btn" onClick={() => setOpen((v) => !v)} data-testid="floating-language-btn"
        aria-haspopup="menu" aria-expanded={open} title="Choose language">
        <Globe size={16} /> <span className="fl-lang-native">{current.native}</span>
      </button>
      {open && (
        <div className="fl-lang-menu" role="menu" data-testid="floating-language-menu">
          {LANGUAGES.map((l) => (
            <button key={l.code} role="menuitem" className={l.code === lang ? "on" : ""}
              onClick={() => { setLang(l.code); setOpen(false); }} data-testid={`floating-lang-${l.code}`}>
              <span>{l.native}</span><small>{l.label}</small>
              {l.code === lang && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
